import type { NavigationRefs } from './types'
import { getPageFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'navigation'
const navigationRefProvider = getPageFeatureBoundRefProvider(featureName)

const navigationRefs: NavigationRefs = {
	navigateTo: () => navigationRefProvider(['navigateTo']),
}

export { navigationRefs }
